import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";

const BAR_COLOR = "#065fb2"; // flood hazard blue

export default function RiskBarChart({ bars, xLabel, yLabel, height = 240 }) {
  const { periods, depths } = useMemo(
    () => ({
      periods: bars.map((bar) => bar.period),
      depths: bars.map((bar) => bar.depthMeters),
    }),
    [bars],
  );

  if (!bars.length) return null;

  return (
    <Box sx={{ height, width: "100%" }}>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: periods,
            label: xLabel,
          },
        ]}
        yAxis={[{ label: yLabel }]}
        series={[
          {
            data: depths,
            label: yLabel,
            color: BAR_COLOR,
            // Show the human-readable depth (mm/cm/m) in the tooltip.
            valueFormatter: (value, context) =>
              bars[context?.dataIndex]?.displayValue ?? String(value),
          },
        ]}
        margin={{ top: 12, bottom: 48, left: 72, right: 12 }}
        sx={{
          // Nudge the y-axis label further left so it clears the tick values.
          [`& .${axisClasses.left} .${axisClasses.label}`]: {
            transform: "translateX(-24px)",
          },
        }}
        slotProps={{ legend: { hidden: true } }}
      />
    </Box>
  );
}
